module.exports = __webpack_public_path__ + "e6d4fd8f7089ff39b31f3975a50d603e.svg";